interface MobileUnderAttributes {
  'data-covered'?: boolean
  'aria-hidden'?: boolean
  inert?: string
}

/** The page behind an open phone pane: dimmed by CSS and removed from focus. */
export function mobileUnderProps(
  isMobile: boolean,
  covered: boolean,
): MobileUnderAttributes {
  if (!isMobile) return {}
  return {
    'data-covered': covered,
    'aria-hidden': covered ? true : undefined,
    // React 18 forwards the native boolean attribute using its string form.
    inert: covered ? '' : undefined,
  }
}
